module.exports = __webpack_public_path__ + "static/media/IC_peer.2f71594a.svg";